import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useIntl, FormattedMessage } from "react-intl";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Flex, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";

export const LiveSetupLobbyConfirmation = ({ onConfirmationChange }) => {
  const intl = useIntl();
  const [stepsConfirmation, setStepsConfirmation] = useState();
  const [streamlabsConfirmation, setStreamlabsConfirmation] = useState();
  const [liveConfirmation, setLiveConfirmation] = useState();

  useEffect(() => {
    onConfirmationChange(stepsConfirmation && streamlabsConfirmation && liveConfirmation);
  }, [stepsConfirmation, streamlabsConfirmation, liveConfirmation]);

  return (
    <GridItem gridRow="5" gridColumn="1 / span 8" marginTop={4}>
      <Flex flexDirection="column" marginTop={4}>
        <Text size="small" fontWeight="regular" as="h3" textAlign="left">
          <FormattedMessage id="live_sessions.create_lobby.confirmation_title" />
        </Text>
        <Text
          size="medium"
          fontWeight="medium"
          as="h3"
          textAlign="left"
          marginTop={4}
          style={{ position: "relative" }}
        >
          <Form.Checkbox
            size="tiny"
            id="confirmationChanged"
            name="confirmationChanged"
            label={intl.formatMessage({
              id: "live_sessions.create_lobby.confirmation_1",
            })}
            onChange={setStepsConfirmation}
          />
        </Text>
        <Text
          size="medium"
          fontWeight="medium"
          as="h3"
          textAlign="left"
          marginTop={4}
          style={{ position: "relative" }}
        >
          <Form.Checkbox
            size="tiny"
            id="confirmationChanged"
            name="confirmationChanged"
            label={intl.formatMessage({
              id: "live_sessions.create_lobby.confirmation_2",
            })}
            onChange={setStreamlabsConfirmation}
          />
        </Text>
        <Text
          size="medium"
          fontWeight="medium"
          as="h3"
          textAlign="left"
          marginTop={4}
          style={{ position: "relative" }}
        >
          <Form.Checkbox
            size="tiny"
            id="confirmationChanged"
            name="confirmationChanged"
            label={intl.formatMessage({
              id: "live_sessions.create_lobby.confirmation_3",
            })}
            onChange={setLiveConfirmation}
          />
        </Text>
      </Flex>
    </GridItem>
  );
};

LiveSetupLobbyConfirmation.propTypes = {
  onConfirmationChange: PropTypes.func.isRequired,
};

export default LiveSetupLobbyConfirmation;
